import InstantSearch from 'vue-instantsearch/vue3/es'
import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter'

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig()

  nuxtApp.vueApp.use(InstantSearch)

  const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
    server: {
      apiKey: config.public.typesense.apiKey,
      nodes: [
        {
          host: config.public.typesense.host,
          port: parseInt(config.public.typesense.port),
          protocol: config.public.typesense.protocol,
        },
      ],
    },
    additionalSearchParameters: {
      per_page: 24,
    },
    collectionSpecificSearchParameters: {
      DiffusionDB: {
        query_by: 'embedding',
        exclude_fields: ['embedding'],
        vector_query: 'embedding:([], k: 200)',
      },
      VideoDiffusionDB: {
        group_by: 'asset_id',
        query_by: 'embedding',
        exclude_fields: ['embedding'],
        vector_query: 'embedding:([], k: 200)',
      },
    },
  })

  return {
    provide: {
      searchClient: typesenseInstantsearchAdapter.searchClient,
      typesense: typesenseInstantsearchAdapter.typesenseClient,
    },
  }
})
